import * as types from '../../action-types';
import {getMyISOOppurtunity as initialState } from "../../initialState";

const getMyISOOppurtunity = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_MY_ISO_OPPORTURNITY_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_MY_ISO_OPPORTURNITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_MY_ISO_OPPORTURNITY_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_MY_ISO_OPPORTURNITY_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getMyISOOppurtunity;

